module.exports = __webpack_public_path__ + "img/minus.f80789ae.svg";